import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
/* eslint-disable */

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // log the error to an error reporting service
    Bugsnag.start({
      apiKey: '2411ec8e6435bf071474c006677b262d',
      plugins: [new BugsnagPluginReact()]
    });
    Bugsnag.notify(new Error(error, errorInfo));
  }

  render() {
    if (this.state.hasError) {
      // render custom fallback UI
      document.querySelector('html').style.backgroundColor = '#ffffff'
      return (
        <div style={{ textAlign: 'center', margin: '20px 10px' }}>
          <img
            style={{ maxHeight: '200px', width: '100%', objectFit: 'contain' }}
            alt="error" src="https://metiormedia.s3.us-east-1.amazonaws.com/assets/errorImage.png"
          />
          <h1>Woops!</h1>
          <h1>Algo salio mal :(</h1>
          <h3>Abroche su cinturon, hasta que reparemos el error</h3>
          <h3>Vuelva a intentarlo pronto, y recargue la pagina.</h3>
        </div>
      );
    };

    return this.props.children;
  }
}

export default ErrorBoundary;
